import Vue from 'vue'
import VueRouter from 'vue-router'

// components
import LoginPage from '@/components/Login';
import ForgotPasswordPage from '@/components/ForgotPassword/index';
import HomePage from '@/views/Home';
import RegistrationPage from '@/components/Registration';
import SupplierEvaluation from '@/components/SupplierEvaluation';

// users
import UserDashboard from '@/components/common/users/user-dashboard';
import UserCreate from '@/components/common/users/user-create';
import UserModify from '@/components/common/users/user-modify';

// customers
import CustomerDashboard from '@/components/common/customers/customer-dashboard.vue';
import CustomerCreateWizard from '@/components/common/customers/create-wizard/customer-create-wizard.vue';
import CustomerModifyWizard from '@/components/common/customers/modify-wizard/customer-modify-wizard.vue';
import CustomerUserAllocation from '@/components/common/customers/customer-user-allocation.vue';

// customer portal
import CustomerPortal from '@/views/CustomerPortal/customer-portal.vue';
import CustomerFeedback from '@/views/CustomerPortal/feedback/feedback.vue';

// inspection templates
import InspectionTemplateMaint from '@/components/common/inspection-templates/inspection-template-maint.vue';

// opsmanager assessment templates
import GlobalOpsManagerTemplateList from '@/components/common/OpsManagerGlobalAssessments/index.vue';

// inspection alloction pages
import InspectionAllocationList from '@/components/common/inspection-allocation/list.vue';
import InspectionAllocationCreate from '@/components/common/inspection-allocation/create.vue';

// class types
import ClassTypes from '@/components/common/class-types/class-types-main.vue';

// ops manager allocation inspection
import OpsManagerAllocation from '@/components/common/ops-manager-allocations/ops-manager-allocation.vue';

// roles
import RoleDashboard from '@/components/common/roles/role-dashboard';
import RoleCreate from '@/components/common/roles/role-create';
import RoleModify from '@/components/common/roles/role-modify';

// permissions
import RolePermissions from '@/components/common/permissions/permission-maintenance';

// account
import Account from '@/components/common/account/account'
import AccountSettings from '@/components/common/account/account-settings';
import AccountShop from '@/components/common/account/account-shop';
import AccountSystemSettings from '@/components/common/account/account-system-settings';
import AccountUserList from '@/components/common/account/account-users-list';
import AccountUserDashboard from '@/components/common/account/account-users-dashboard'

// communication
import SendEmail from '@/components/common/communication/SendEmail';
import SendSMS from '@/components/common/communication/SendSMS';

// tasks
import TaskDashboard from '@/components/common/tasks/task-dashboard';

// notifications
import NotificationDashboard from '@/components/common/notifications/notification-dashboard';

//file management
import FileManager from '@/components/common/fileManager/file-manager';

// admin reports
import ReportDashboard from '@/components/common/reports/report-dashboard.vue';
import SupervisorTasks from '@/components/common/reports/report-components/supervisor-tasks-report.vue';
import OpsManagerTasks from '@/components/common/reports/report-components/ops-manager-tasks-report.vue';
import ReportSummary from '@/components/common/reports/report-summary.vue';
import OpsVisits from '@/components/common/reports/report-components/Ops-Manager-Visits';
import CustomerFeedbackTaskReport from '@/components/common/reports/report-components/Customer-Tasks-Report.vue';
import MeetingTaskReport from '@/components/common/reports/report-components/Meeting-Tasks-Report.vue';
import CustomerDetail from '@/components/common/reports/report-customerdetail.vue';
import SupplierEvaluationReport from '../components/common/reports/report-components/supplier-evaluation-report.vue';

// customer reports
import CustomerReportDashboard from '@/views/CustomerPortal/customer-reports/report-dashboard.vue';
import CustomerSupervisorTasksReport from '@/views/CustomerPortal/customer-reports/report-components/supervisor-tasks-report.vue';
import CustomerOpsManagerTasksReport from '@/views/CustomerPortal/customer-reports/report-components/ops-manager-tasks-report.vue';
import CustomerReportSummary from '@/views/CustomerPortal/customer-reports/report-summary.vue';
import CustomerOpsVisits from '@/views/CustomerPortal/customer-reports/report-components/Ops-Manager-Visits';

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [{
      path: '/home',
      component: HomePage,
      children: [{
          path: '/users/dashboard',
          name: '',
          component: UserDashboard
        },
        {
          path: '/user/create',
          name: '',
          component: UserCreate,
        },
        {
          path: '/user/modify/:id',
          name: '',
          component: UserModify
        },
        {
          path: '/customers/dashboard',
          name: '',
          component: CustomerDashboard
        },
        {
          path: '/customer/create',
          name: '',
          component: CustomerCreateWizard
        },
        {
          path: '/customer/modify/:id',
          name: '',
          component: CustomerModifyWizard
        },
        {
          path: '/customer-user/allocation',
          name: '',
          component: CustomerUserAllocation
        },
        {
          path: '/ops-manager/class-types',
          name: '',
          component: ClassTypes
        },
        {
          path: '/ops-manager/assessment/templates',
          name: '',
          component: GlobalOpsManagerTemplateList
        },
        {
          path: '/inspection/templates',
          name: '',
          component: InspectionTemplateMaint
        },
        {
          path: '/ops-manager/allocation',
          name: '',
          component: OpsManagerAllocation
        },
        {
          path: '/roles/dashboard',
          name: '',
          component: RoleDashboard
        },
        {
          path: '/roles/create',
          name: '',
          component: RoleCreate
        },
        {
          path: '/roles/modify/:id',
          name: '',
          component: RoleModify
        },
        {
          path: '/roles/permissions/:id',
          name: '',
          component: RolePermissions
        },
        {
          path: '/file/management',
          name: '',
          component: FileManager
        },
        {
          path: '/tasks/dashboard',
          name: '',
          component: TaskDashboard
        },
        {
          path: '/notifications/dashboard',
          name: '',
          component: NotificationDashboard
        },
        {
          path: '/communication/email',
          name: '',
          component: SendEmail
        },
        {
          path: '/communication/sms',
          name: '',
          component: SendSMS
        },
        {
          path: '/report-dashboard',
          name: '',
          component: ReportDashboard
        },
        {
          path: '/report-summary',
          name: '',
          component: ReportSummary
        },
        {
          path: '/report/supervisor-tasks',
          name: '',
          component: SupervisorTasks
        }, {
          path: '/report/ops-manager-tasks',
          name: '',
          component: OpsManagerTasks
        },
        {
          path: '/report/ops-manager-visits',
          name: '',
          component: OpsVisits
        },
        {
          path: '/report/customer-tasks',
          name: '',
          component: CustomerFeedbackTaskReport
        },
        {
          path: '/report/meeting-tasks',
          name: '',
          component: MeetingTaskReport
        },
        {
          path: '/report/customer-detail',
          name: '',
          component: CustomerDetail
        },
        {
          path: '/report/supplier-evaluations',
          name: '',
          component: SupplierEvaluationReport
        },

      ]
    },
    {
      path: '/user/create',
      name: '',
      component: UserCreate,
    },
    {
      path: '/customerportal',
      component: CustomerPortal,
      children: [{
          path: '/customerportal/feedback',
          component: CustomerFeedback,
          name: ''
        },
        {
          path: '/customerportal/report/dashboard',
          component: CustomerReportDashboard,
          name: ''
        },
        {
          path: '/customerportal/report/summary',
          component: CustomerReportSummary,
          name: ''
        },
        {
          path: '/customerportal/report/supervisor-tasks',
          component: CustomerSupervisorTasksReport,
          name: ''
        },
        {
          path: '/customerportal/report/ops-manager-tasks-report',
          component: CustomerOpsManagerTasksReport,
          name: ''
        },
        {
          path: '/customerportal/report/ops-manager-visits',
          name: '',
          component: CustomerOpsVisits
        }
      ]
    },
    {
      path: '/login',
      component: LoginPage
    },
    {
      path: '/customers/dashboard',
      name: '',
      component: CustomerDashboard
    },
    {
      path: '/customer/create',
      name: '',
      component: CustomerCreateWizard
    },
    {
      path: '/customer/modify/:id',
      name: '',
      component: CustomerModifyWizard
    },
    {
      path: '/inspections',
      name: '',
      component: InspectionAllocationList
    },
    {
      path: '/inspection/allocate',
      name: '',
      component: InspectionAllocationCreate
    },
    {
      path: '/inspection/templates',
      name: '',
      component: InspectionTemplateMaint
    },
    {
      path: '/roles/dashboard',
      name: '',
      component: RoleDashboard
    },
    {
      path: '/roles/create',
      name: '',
      component: RoleCreate
    },
    {
      path: '/roles/modify/:id',
      name: '',
      component: RoleModify
    },
    {
      path: '/roles/permissions/:id',
      name: '',
      component: RolePermissions
    },
    {
      path: '/file/management',
      name: '',
      component: FileManager
    },
    // {
    //   path: '/dashboards/dashboard1',
    //   name: '',
    //   component: HomeDashboard1
    // },
    // {
    //   path: '/dashboards/dashboard2',
    //   name: '',
    //   component: HomeDashboard2
    // },
    // {
    //   path: '/dashboards/dashboard3',
    //   name: '',
    //   component: HomeDashboard3
    // },
    {
      path: '/tasks/dashboard',
      name: '',
      component: TaskDashboard
    },
    {
      path: '/notifications/dashboard',
      name: '',
      component: NotificationDashboard
    },
    {
      path: '/communication/email',
      name: '',
      component: SendEmail
    },
    {
      path: '/communication/sms',
      name: '',
      component: SendSMS
    },
    {
      path: '/account',
      component: Account,
      children: [{
          path: '/account/settings',
          name: '',
          component: AccountSettings
        },
        {
          path: '/account/shop',
          name: '',
          component: AccountShop
        },
        {
          path: '/account/system-settings',
          name: '',
          component: AccountSystemSettings
        },
        {
          path: '/account/user/list',
          name: '',
          component: AccountUserList
        },
        {
          path: '/account/user/dashboard',
          name: '',
          component: AccountUserDashboard
        }
      ]
    },
    {
      path: '/login',
      component: LoginPage
    },
    {
      path: '/register',
      component: RegistrationPage
    },
    {
      path: '/forgot_password',
      component: ForgotPasswordPage
    },
    {
      path: '/supplier_evaluation/:CustomerID',
      component: SupplierEvaluation
    },
    // otherwise redirect to login
    {
      path: '*',
      redirect: '/login'
    }
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/register', '/supplier_evaluation'];
  let authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('refreshToken');
  publicPages.forEach(element => {
    if (authRequired) {
      authRequired = to.path.indexOf(element) !== -1
    }
  });
  if (authRequired && loggedIn.indexOf('null') > -1) {
    return next('/login');
  }

  next();
});

export default router